"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAthenaRecurringQueries = exports.validateAthenaRecurringQuery = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const athenaValidate_1 = require("./athenaValidate");
const validateAthenaRecurringQuery = (params) => {
    const { athenaRecurringQuery, globalRecurringDateConfigs } = params;
    const { name, globalRecurringDateConfigFields, variables, bindings, queryString, } = athenaRecurringQuery;
    const errors = [];
    // *** Manage query name ***
    if (name === '') {
        errors.push('Athena Recurring Query name is empty');
    }
    // *** Manage recurring date configs ***
    let detectedMissingDateConfig = false;
    if (globalRecurringDateConfigFields.length === 0) {
        errors.push(`Detected empty recurring fields for [name:${name}], should use normal queries instead`);
        detectedMissingDateConfig = true;
    }
    const dateConfigVariables = [];
    for (const dateConfigField of globalRecurringDateConfigFields) {
        const targetConfig = globalRecurringDateConfigs.find(({ field }) => field === dateConfigField);
        if (!targetConfig) {
            errors.push(`Athena Recurring Query references nonexisting recurring date field [field:${dateConfigField}] [name:${name}]`);
            detectedMissingDateConfig = true;
            break;
        }
        // Just using dummy placeholder here as value doesn't actually matter, just need to
        // pass along variable to indicate that it exists for query string validation
        dateConfigVariables.push({
            name: dateConfigField,
            value: '2000-01-01',
            parseNumber: false,
        });
    }
    // *** Manage query string, variables, bindings ***
    if (queryString === '') {
        errors.push('Athena Recurring query string is empty');
    }
    if (!detectedMissingDateConfig) {
        const queryErrors = (0, athenaValidate_1.validateAthenaQuery)({
            variables: [...dateConfigVariables, ...variables],
            bindings,
            query: queryString,
        });
        queryErrors.forEach((err) => errors.push(err));
    }
    return errors;
};
exports.validateAthenaRecurringQuery = validateAthenaRecurringQuery;
const validateAthenaRecurringQueries = (params) => {
    const { athenaRecurringQueries, globalRecurringDateConfigs } = params;
    const queryResultVariables = [];
    const errors = [];
    const queryNameSet = new Set();
    for (const athenaRecurringQuery of athenaRecurringQueries) {
        const { name, columnNames, globalRecurringDateConfigFields, } = athenaRecurringQuery;
        // *** Manage query results (no validation occurs here) ***
        // Subsequent logic will handle validation from this flow, this is purely
        // just to accumulate and record the potential output variables
        const maxRecurDateCount = globalRecurringDateConfigFields.reduce((count, field) => {
            const targetConfig = globalRecurringDateConfigs.find((dateConfig) => field === dateConfig.field);
            return Math.max(count, targetConfig?.maxCount ?? -1);
        }, -1);
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < maxRecurDateCount; idx += 1) {
            for (const columnName of columnNames) {
                queryResultVariables.push(`${name}.${columnName}${(0, formula_engine_1.generateVarIdxSuffix)(idx)}`);
            }
        }
        // *** Manage duplicate query name ***
        if (queryNameSet.has(name)) {
            errors.push(`Duplicate Athena Recurring Query name detected: "${name}"`);
            continue;
        }
        queryNameSet.add(name);
        // *** Manage full Athena Recurring Query validation ***
        const athenaRecurringQueryErrors = (0, exports.validateAthenaRecurringQuery)({
            athenaRecurringQuery,
            globalRecurringDateConfigs,
        });
        athenaRecurringQueryErrors.forEach((err) => errors.push(err));
        // *** Manage column names ***
        if (columnNames.length === 0) {
            errors.push(`Athena Recurring Query column names have not been set [name:${name}]`);
        }
        const columnNameSet = new Set();
        for (const columnName of columnNames) {
            if (columnNameSet.has(columnName)) {
                errors.push(`Detected duplicate Athena Recurring Query column [column:${columnName}] [name:${name}]`);
                continue;
            }
            columnNameSet.add(columnName);
        }
    }
    return { queryResultVariables, errors };
};
exports.validateAthenaRecurringQueries = validateAthenaRecurringQueries;
//# sourceMappingURL=athenaRecurringQueryValidate.js.map